import { useState } from 'react'
import {
  COLOR_PRESETS,
  DARK_DEFAULT_PRESET,
  LIGHT_DEFAULT_PRESET,
  type ColorPreset,
} from '@/components/Configuracao/appearanceColorPresets'
import { AppearanceCoresModeSection } from '@/components/Configuracao/AppearanceCoresModeSection'
import { AppearanceCoresPresetsSection } from '@/components/Configuracao/AppearanceCoresPresetsSection'
import { AppearanceCoresDegradeSection } from '@/components/Configuracao/AppearanceCoresDegradeSection'
import { AppearanceCoresManualGroups } from '@/components/Configuracao/AppearanceCoresManualGroups'
import { AppearanceCoresLivePreview } from '@/components/Configuracao/AppearanceCoresLivePreview'
import type { AppearanceCoresTabProps } from '@/components/Configuracao/appearanceTypes'

export function AppearanceCoresTab({ draft, updateDraft, setTheme }: AppearanceCoresTabProps) {
  const [activePreset, setActivePreset] = useState<string | null>(null)
  const currentMode = draft.mode ?? 'light'

  const handleApplyPreset = (preset: ColorPreset) => {
    setActivePreset(preset.id)
    updateDraft(preset.colors)
    setTheme(preset.colors)
  }

  const handleSwitchMode = (mode: 'dark' | 'light') => {
    const base = mode === 'dark' ? DARK_DEFAULT_PRESET.colors : LIGHT_DEFAULT_PRESET.colors
    setActivePreset(mode === 'dark' ? 'dark-default' : 'light-white')
    updateDraft({ ...base, mode })
    setTheme({ ...base, mode })
  }

  const basePreset = currentMode === 'dark' ? DARK_DEFAULT_PRESET : LIGHT_DEFAULT_PRESET
  const palettePresets = COLOR_PRESETS.filter((p) => !p.colors.mode || p.colors.mode === currentMode)
  const allPresets = [basePreset, ...palettePresets]

  return (
    <div className="space-y-6">
      <AppearanceCoresModeSection currentMode={currentMode} onSwitchMode={handleSwitchMode} />
      <AppearanceCoresPresetsSection
        currentMode={currentMode}
        activePreset={activePreset}
        allPresets={allPresets}
        onApplyPreset={handleApplyPreset}
      />
      {currentMode === 'light' && (
        <AppearanceCoresDegradeSection
          draft={draft}
          onClearPreset={() => setActivePreset(null)}
          updateDraft={updateDraft}
        />
      )}
      <AppearanceCoresManualGroups
        draft={draft}
        onClearPreset={() => setActivePreset(null)}
        updateDraft={updateDraft}
      />
      <AppearanceCoresLivePreview draft={draft} />
    </div>
  )
}
